import { ModalOverlay, Modal, Dialog } from "@/components/application/modals/modal";
import { LoadingIndicator } from "@/components/application/loading-indicator/loading-indicator";
import { useTranslation } from "react-i18next";

interface AccountSwitchOverlayProps {
    isOpen: boolean;
}

export const AccountSwitchOverlay = ({ isOpen }: AccountSwitchOverlayProps) => {
    const { t } = useTranslation('common');

    return (
        <ModalOverlay isOpen={isOpen} onOpenChange={() => {}}>
            <Modal>
                <Dialog>
                    <div className="rounded-xl bg-primary p-8 shadow-lg ring-1 ring-secondary">
                        <div className="flex flex-col items-center gap-4">
                            <LoadingIndicator type="line-spinner" size="lg" />
                            <p className="text-lg font-semibold text-primary">
                                {t('accountSwitch.switching')}
                            </p>
                        </div>
                    </div>
                </Dialog>
            </Modal>
        </ModalOverlay>
    );
};

